<div class="dashboard-preview dashboard-preview-{{color}}" [class.display-names]="displayNames"
     style="padding: {{padding}};">
  <div *ngIf="pbiDashboard; else insightsDashboard" class="dashboard-preview__pbi">
    <div>
      <img src="/assets/img/Power_BI_logo.svg" alt="PowerBI" />
    </div>
  </div>
  <ng-template #insightsDashboard>
    <div *ngIf="invalidLayout" class="dashboard-preview__invalid">
      <i class="fal fa-exclamation-circle mr-6 p-relative ot-1"></i>
      <span>Failed to load dashboard layout information.</span>
    </div>
    <div *ngIf="emptyLayout" class="dashboard-preview__empty">
      <i class="fal fa-info-circle mr-6 p-relative ot-1"></i>
      <span>This dashboard is empty.</span>
    </div>
    <div *ngIf="!invalidLayout && !emptyLayout" class="dashboard-preview__grid" [style]="gridStyle">
      <div *ngFor="let gridElement of gridElements"
           class="dashboard-preview__grid-element {{gridElement.classes}}"
           [class.p-0]="!displayNames"
           [style]="gridElement.style"
           [title]="gridElement.name">
        <div class="dashboard-preview__grid-element-content">
          <div class="dashboard-preview__grid-element-icon"
               style="
                background-image: url('{{gridElement.iconImageUrl}}');
                {{gridElement.smallIcon ? smallIconSizeStyle : iconSizeStyle}}"></div>
          <div *ngIf="displayNames" class="dashboard-preview__grid-element-name-margin" [style]="nameMarginStyle"></div>
          <div *ngIf="displayNames" class="dashboard-preview__grid-element-name" [style]="gridElement.textStyle">{{gridElement.name}}</div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
